import cookieModel from './cookieModel';
import getBaseUrl from '../utils/baseUrl';

const fetchModel = {
  // Helper function to handle authentication errors
  handleAuthError: function(response) {
    if (response.status === 401 || response.status === 403) {
      // Clear both types of authentication cookies
      cookieModel.removeCookie('ticketlab_access');
      cookieModel.removeCookie('ticketlab_staff_access');
      
      // Redirect to login page
      const baseUrl = getBaseUrl();
      window.location.href = baseUrl + '/login';
      return true; // Indicates auth error was handled
    }
    return false; // No auth error
  },

  post: function(url, postBody, callback) {
    let fetchUrl = process.env.REACT_APP_API_URL + url;

    fetch(fetchUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookieModel.getCookie('ticketlab_access')
      },
      body: JSON.stringify(postBody)
    })
    .then(r => {
      // Check for authentication errors before parsing JSON
      if (fetchModel.handleAuthError(r)) {
        return Promise.reject(new Error('Authentication error - redirecting to login'));
      }
      return r.json();
    })
    .then(response => {
      callback(response);
    })
    .catch(e => {
      // Only call callback for non-auth errors
      if (!e.message || !e.message.includes('Authentication error')) {
        callback({ error: e });
      }
    });
  },

  postStaff: function(url, postBody, callback) {
    let fetchUrl = process.env.REACT_APP_API_URL + url;

    fetch(fetchUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': cookieModel.getCookie('ticketlab_staff_access')
      },
      body: JSON.stringify(postBody)
    })
    .then(r => {
      // Check for authentication errors before parsing JSON
      if (fetchModel.handleAuthError(r)) {
        return Promise.reject(new Error('Authentication error - redirecting to login'));
      }
      return r.json();
    })
    .then(response => {
      callback(response);
    })
    .catch(e => {
      // Only call callback for non-auth errors
      if (!e.message || !e.message.includes('Authentication error')) {
        callback({ error: e });
      }
    });
  }
};

export default fetchModel;
